<template v-if="globaljs.mb_staff !== 'Worker'">
	<!-- 목록 추가 후 -->
	<ul v-if="filteredItems.length > 0 || checkedItems.length > 0" class="lab_r_list r_hospital_list">
		<li v-for="(item, index) in filteredItems" :key="index">
			<div class="lab_check">
				<input type="checkbox" name="lab_check[]" :value="item.mb_boss_id" checked readonly disabled>
			</div>
			<div class="lab_info">
				<p class="lab_tit">{{ item.mb_nick }}</p>
				<p class="lab_txt">{{ item.mb_busi_addr }}</p>
				<p class="lab_txt">{{ item.mb_tel }}&nbsp;/&nbsp;{{ item.mb_hp }}</p>
			</div>
		</li>
		<li v-for="(item, index) in checkedItems" :key="index">
			<div class="lab_check">
				<input type="checkbox" name="lab_check[]" :value="item.mb_boss_id" checked="" @click="uncheck_partner($event, item.mb_boss_id)">
			</div>
			<div class="lab_info">
				<p class="lab_tit">{{ item.mb_nick }}</p>
				<p class="lab_txt">{{ item.mb_busi_addr }}</p>
				<p class="lab_txt">{{ item.mb_tel }}&nbsp;/&nbsp;{{ item.mb_hp }}</p>
			</div>
		</li>
	</ul>
	<!-- 목록 추가 전 -->
	<div v-else class="lab_list_none">매칭된 거래처가 없습니다.</div>

	<form v-if="checkedItems.length > 0" ref="form_match_add" id="form_match_add" :action="`${SERVER_URL}/api/app/matching/add`"
		@submit.prevent="form_match_add_submit()" method="post" autocomplete="off">
		<div class="regist_btn btn_style1" @click="form_match_add_submit()">완료</div>
	</form>
</template>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as globaljs from '@/components/utils/global';
import * as commonjs from '@/components/utils/common';

const router = useRouter();
const route = useRoute();

if(globaljs.mb_staff === 'Worker') { commonjs.authSwal(); }

// Props
const props = defineProps({
	filteredItems: {
		type: Array,
		required: true
	},
	checkedItems: {
		type: Array,
		required: true
	},
	waitingItemsCount: {
		type: Number,
		required: true
	},
});

let submitingFlag = false; // 플래그 변수
const withSubmitFlag = async (asyncFunc) => {
	if (submitingFlag) return; // 요청 중복 방지
		submitingFlag = true; // 요청 시작 시 플래그 설정
	try {
		await asyncFunc(); // 비동기 함수 실행
	} finally {
		submitingFlag = false; // 요청이 끝나면 플래그 해제
	}
};

const emit = defineEmits(['remove-partner']);

onMounted(async () => {
	if(globaljs.mb_staff !== 'Worker') { 
		console.debug(props.filteredItems);
		console.debug(props.waitingItemsCount);
	}
});

const uncheck_partner = (event, mb_boss_id) => {
	event.preventDefault(); // 240808 여러개중에서 맨 위에꺼만 클릭시 맨 위에 있는게 unchechked가 되어버림. 그래서 클릭이벤트 막음
	emit('remove-partner', mb_boss_id);
}

async function form_match_add_submit() {
	await withSubmitFlag(async () => {
		// 모든 input 요소들 중 name 속성이 other_mb_ids[]인 요소들을 선택합니다.
		var inputElements = document.querySelectorAll(".r_hospital_list input[type='checkbox']");
		// disabled 속성이 없는 요소들만 필터링합니다.
		var enabledInputs = Array.from(inputElements).filter(function (input) {
			return !input.disabled;
		});
		// enabledInputs의 길이를 카운팅합니다.
		//const enabledInputs = document.querySelectorAll(".r_hospital_list input[type='checkbox']:not([disabled]");
		var count = enabledInputs.length;

		if (count < 1) {
			commonjs.formSwal('요청 불가', `매칭 요청할 거래처가 없습니다`, '#confirm_hospital_list', 'self');
			return false;
		}

		const is_confirm = await commonjs.confirmSwal('매칭요청 확인', `선택한 ${count}개의 거래처에 매칭 요청을 하시겠습니까?`);
		if (!is_confirm) {
			return false;
		}

		const params = new URLSearchParams();
		params.append('acc_type', globaljs.acc_type); // 240905 매칭요청했다가, 이미 나한테 요청보낸게 있으면 수락하고, 매칭에도 insert하려고.
		params.append('mb_boss_id', globaljs.mb_boss_id);
		// disabled 속성이 없는 요소들의 값을 FormData에 추가합니다.
		inputElements.forEach(function (input) {
			if (!input.disabled) {
				params.append('other_mb_ids[]', input.value);
			}
		});

		// URLSearchParams를 객체로 변환
		const object = {};
		params.forEach((value, key) => {
			if (key.endsWith('[]')) {
				const arrayKey = key.slice(0, -2);
				if (!object[arrayKey]) {
					object[arrayKey] = [];
				}
				object[arrayKey].push(value);
			} else {
				object[key] = value;
			}
		});

		// 결과 확인용 로그 출력
		const jsonString = JSON.stringify(object, null, 2); // 들여쓰기 2칸으로 JSON 문자열화
	console.info(jsonString);

		try {
			const response = await axios.post(`${SERVER_URL}/api/app/matching/unmatched`, params);
	console.debug(response.data.result);
			if (globaljs.acc_type === 'lab') { // 매칭된적 없는, 기공소일때
				if ( (props.filteredItems.length + props.waitingItemsCount) < 1 && parseInt(response.data.result.count, 10) < 1) {
					Swal.fire({
						title: '매칭 요청 완료',
						//text: txt,
						html: `<div style="word-break: keep-all;">'매칭 요청이 완료되었습니다. <br/>보철물 기본 설정이 필요합니다.'</div>`, // txt의 줄바꿈을 <br> 태그로 대체
						icon: 'success',
						confirmButtonText: '확인',
						allowOutsideClick: false,  // 외부 클릭 방지
						allowEscapeKey: false,      // ESC 키 눌러서 닫기 방지
						returnFocus: false,
					}).then((result) => {
						if (result.isConfirmed) {
							setTimeout(function () {
								if(opener){
									opener.location.href = '/manage_prosthesis';
								}
								self.close();
							}, 100);
						}
					});
				} else {
					if(opener){
						opener.location.href = '/unmatched_partner'; // 대기중 거래처 페이지
					}
					commonjs.formSwal('매칭 요청 완료', '매칭 요청이 완료되었습니다.', 'popup');	
				}
			} else {
				if(opener){
					opener.location.href = '/unmatched_partner'; // 대기중 거래처 페이지
				}
				commonjs.formSwal('매칭 요청 완료', '매칭 요청이 완료되었습니다.', 'popup');
			}
		} catch (error) {
			console.error(error?.response?.data);
			commonjs.formSwal(`필수 입력`, error?.response?.data?.errors[0]?.msg);
		}
	});
}
</script>